/* eslint-disable @repo/internal/deprecations/deprecation-ticket-required -- VOLTC-139 tracks removal of these deprecated re-export shims. */
/**
 * @deprecated Import from the generated per-export subpath instead.
 */
export { default } from './portal';
/**
 * @deprecated Import from the generated per-export subpath instead.
 */
export type { PortalEvent, PortalProps } from './types';
/**
 * @deprecated Import from the generated per-export subpath instead.
 */
export { PORTAL_MOUNT_EVENT, PORTAL_UNMOUNT_EVENT } from './constants';
